import { EcEnv } from '@castlery/config';
export const removeRegionInPath = (path: string) => {
  if (!path) {
    return path;
  }
  // remove region from path
  const region = EcEnv.NEXT_PUBLIC_COUNTRY.toLowerCase();
  return path.replace(`/${region}/`, '');
};

export function getShippingSelectorLabel() {
  if (typeof window === 'undefined') {
    return 'Other';
  }
  const pathname = window.location.pathname;
  let label = '';
  const type = window.DY.recommendationContext?.type;

  switch (type) {
    case 'CART':
      if (pathname.includes('/cart')) {
        label = 'Fullcart';
      } else {
        //校验 mini cart 状态
        label = 'Minicart';
      }
      break;
    case 'PRODUCT':
      if (pathname.includes('/product')) {
        label = 'PDP';
      } else {
        label = 'PLA';
      }
      break;
    case 'CATEGORY':
      label = 'Quickship';
      break;
    case 'OTHER':
      if (pathname.includes('/checkout/shipping-address')) {
        label = 'Ordersummary';
      } else {
        label = 'Other';
      }
      break;
    default:
      label = 'Other';
      break;
  }
  return label;
}
